var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-man';
                    var viewUrl = 'sprite.svg#view-icon-man';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 65 66',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };